import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ZoomIn",
  "use": "icon-ZoomIn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ZoomIn\">\r\n    <defs>\r\n        <style type=\"text/css\"></style>\r\n    </defs>\r\n    <path d=\"M454.4 454.4V0h96v454.4h454.4v96H550.4v454.4H454.4V550.4H0V454.4h454.4z\" fill=\"#999999\" p-id=\"2975\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol